/**
 * The house at a glance, before sign-in.
 *
 * Unauthenticated on purpose — there is no token to send at the gate, which is the
 * whole point. Everything it returns comes from fabric-api's `/public/glance`
 * allowlist, where each entity was admitted only after answering *would this tell a
 * stranger whether the house is empty?* Solar, battery, grid, tank and outside
 * temperature do not. Indoor climate, doors, motion and the alarm are excluded at
 * that endpoint, not here.
 *
 * Fails to an empty array, which hides the strip. A login screen showing a broken
 * panel is a login screen nobody trusts, at exactly the moment they are deciding
 * whether to.
 */
const FABRIC_API = import.meta.env.VITE_FABRIC_API_URL ?? "";

export type Stat = { key: string; label: string; value: number | null; unit: string; text: string | null };

class Glance {
  stats = $state<Stat[]>([]);

  constructor() {
    if (!FABRIC_API) return;
    void this.load();
  }

  async load(): Promise<void> {
    try {
      // No Authorization header, and no `credentials` — that is what makes the
      // endpoint's wildcard CORS safe.
      const res = await fetch(`${FABRIC_API}/public/glance`, { signal: AbortSignal.timeout(8000) });
      if (!res.ok) return;
      const body = (await res.json()) as { stats?: Stat[] };
      this.stats = Array.isArray(body.stats) ? body.stats : [];
    } catch {
      // Leave it empty. The gate renders without the strip.
    }
  }
}

export const glance = new Glance();
